import { render, staticRenderFns } from "./Article4Content.vue?vue&type=template&id=392c7c93&scoped=true"
var script = {}
import style0 from "./Article4Content.vue?vue&type=style&index=0&id=392c7c93&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392c7c93",
  null
  
)

export default component.exports